import React from "react";

/**
 * Bullet-list rules editor. Each rule is a single line of text. Users add
 * rules with the + button and remove with the × button. Rules are joined
 * with newlines on save and split on render so the existing `rules`
 * column on holder_groups stays text — no schema change.
 */
const MAX_RULES = 12;
// Short enough that a rule fits one line in the kanban-style rules
// card grid column. Was 140 — wrapped 3-4 lines on long rules and
// broke the grid alignment.
const MAX_RULE_LEN = 80;

export default function RulesEditor({ value, onChange, disabled }) {
  // `value` is the saved newline-joined string. Preserve empty rows so
  // a freshly-added blank rule doesn't get filtered away on the next
  // render. Empty/whitespace-only rules get stripped at save time by
  // the parent submit handler — this component is just the editor view.
  const raw = value === "" || value == null ? [] : value.split("\n");
  const rules = raw.length > 0 ? raw : [""];

  const update = (i, v) => {
    const next = [...rules];
    next[i] = v.slice(0, MAX_RULE_LEN);
    onChange(next.join("\n"));
  };
  const add = () => {
    if (rules.length >= MAX_RULES) return;
    onChange([...rules, ""].join("\n"));
  };
  const remove = (i) => {
    const next = rules.filter((_, idx) => idx !== i);
    onChange(next.length === 0 ? "" : next.join("\n"));
  };

  return (
    <div className="pm-rules-edit">
      {rules.map((r, i) => (
        <div key={i} className="pm-rules-edit__row">
          <span className="pm-rules-edit__bullet" aria-hidden="true">•</span>
          <input
            type="text"
            className="pm-rules-edit__input"
            placeholder={i === 0 ? "e.g. No FUD without proof" : `Rule ${i + 1}`}
            value={r}
            maxLength={MAX_RULE_LEN}
            disabled={disabled}
            onChange={(e) => update(i, e.target.value)}
          />
          <span className="pm-rules-edit__count" aria-hidden="true">
            {r.length}/{MAX_RULE_LEN}
          </span>
          {(rules.length > 1 || r) && (
            <button
              type="button"
              className="pm-rules-edit__remove"
              onClick={() => remove(i)}
              disabled={disabled}
              aria-label="Remove rule"
            >
              <svg width="12" height="12" viewBox="0 0 12 12" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round">
                <path d="M2 2 L10 10 M10 2 L2 10" />
              </svg>
            </button>
          )}
        </div>
      ))}
      {rules.length < MAX_RULES && (
        <button
          type="button"
          className="pm-rules-edit__add"
          onClick={add}
          disabled={disabled}
        >
          + add rule
        </button>
      )}
    </div>
  );
}
